export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/tyreFaulty.5376f75c.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};